import api from './api';

const withStoreId = (storeId, config = {}) => (storeId
  ? { ...config, _storeId: storeId }
  : config);

const ProductSaleService = {
  createProductSale: async (storeId, sale) => {
    const response = await api.post('/product-sales', sale, { _storeId: storeId });
    return response.data;
  },

  getProductSales: async ({
    storeId,
    from,
    to,
    teamMemberId,
    customerId,
    channel,
    statuses,
    pageIndex = 0,
    itemsPerPage = 20,
  } = {}) => {
    const response = await api.get('/product-sales', withStoreId(storeId, {
      params: {
        from,
        to,
        teamMemberId,
        customerId,
        channel,
        statuses,
        pageIndex,
        itemsPerPage,
      },
    }));

    return {
      data: response.data?.data || [],
      pageIndex: response.data?.pageIndex ?? 0,
      itemsPerPage: response.data?.itemsPerPage ?? itemsPerPage,
      totalItems: response.data?.totalItems ?? 0,
    };
  },

  voidProductSale: async (storeId, saleId) => {
    await api.post(`/product-sales/${saleId}/void`, null, { _storeId: storeId });
  },
};

export default ProductSaleService;
